import React from "react";
import { FiChevronDown } from "react-icons/fi";
import AppChip from "../ui/AppChip";
import "./ServiceFilterAccordion.css";

export default function ServiceFilterAccordion({
  sections = [],
  selected = [],
  onToggle,
  expandedSections = {},
  onToggleSection,
}) {
  return (
    <div className="service-filter-accordion" role="list">
      {sections.map((section) => {
        const isOpen = Boolean(expandedSections[section.id]);
        const selectedInSection = section.items.filter((item) => selected.includes(item)).length;
        const panelId = `service-section-${section.id}`;

        return (
          <article
            key={section.id}
            className={`service-filter-accordion__item${isOpen ? " service-filter-accordion__item--open" : ""}`}
            role="listitem"
          >
            <button
              type="button"
              className="service-filter-accordion__trigger"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => onToggleSection?.(section.id)}
            >
              <span className="service-filter-accordion__title-wrap">
                <span className="service-filter-accordion__title">{section.title}</span>
                {selectedInSection > 0 ? (
                  <span className="service-filter-accordion__badge" aria-label={`${selectedInSection} selected`}>
                    {selectedInSection}
                  </span>
                ) : null}
              </span>
              <FiChevronDown className="service-filter-accordion__chevron" aria-hidden />
            </button>

            <div
              className={`service-filter-accordion__panel-wrap${isOpen ? " service-filter-accordion__panel-wrap--open" : ""}`}
            >
              <div
                id={panelId}
                className="service-filter-accordion__panel"
                role="region"
                aria-label={section.title}
                aria-hidden={!isOpen}
              >
                <div className="service-filter-accordion__chips">
                  {section.items.map((item) => (
                    <AppChip
                      key={item}
                      label={item}
                      selected={selected.includes(item)}
                      onClick={() => onToggle?.(item)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
